module.exports = __webpack_public_path__ + "static/media/mu.46514c80.svg";